<script>
  import { setupI18n } from '@button/ui';
  import { QueryClient, QueryClientProvider } from '@tanstack/svelte-query';
  import { Spinner } from 'flowbite-svelte';
  import { Route, Router } from 'svelte-routing';
  import CuratedByHome from './pages/CuratedByHome.svelte';
  import CuratedByPage from './pages/CuratedByPage.svelte';
  import CuratedByPreview from './pages/CuratedByPreview.svelte';

  const setupI18nResult = setupI18n();
  const queryClient = new QueryClient();
</script>

{#await setupI18nResult}
  <div class="absolute flex h-full w-full items-center justify-center">
    <Spinner />
  </div>
{:then}
  <QueryClientProvider client={queryClient}>
    <Router>
      <Route path="/draft">
        <CuratedByPreview />
      </Route>
      <Route path="/">
        <CuratedByHome />
      </Route>
      <Route path="/*">
        <CuratedByPage />
      </Route>
    </Router>
    <div id="amazon-root" />
  </QueryClientProvider>
{/await}

<style lang="postcss" global>
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
  @layer utilities {
    .no-scrollbar::-webkit-scrollbar {
      display: none; /* Chrome, safari, opera */
    }

    .no-scrollbar {
      -ms-overflow-style: none; /* IE 🤮, and Edge */
      scrollbar-width: none; /* firefox */
    }
  }
  :global(html) {
    font-family: 'Inter', sans-serif;
    background: #ffffff;
    letter-spacing: -0.0128em;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px #fafafa inset !important;
  }
  @layer base {
    :root {
      --color-input-focus: 0 119 255;
      --color-input-error: 207 19 34;
      --color-input-success: 56 158 13;
    }
  }
  #amazon-root {
    display: none;
  }
</style>
